import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import SubscribeForm from "./SubscribeForm";
import Reveal from "./Reveal";
import { Sticker } from "./Stickers";

function UnreleasedScreen() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 select-none blur-[7px]"
    >
      <div className="mx-4 mt-8 flex items-center justify-between">
        <span className="h-2.5 w-14 rounded bg-stone-300" />
        <span className="h-5 w-5 rounded-full bg-pastel-pink" />
      </div>
      <div className="mx-4 mt-6">
        <span className="block h-4 w-28 rounded bg-stone-800/80" />
        <span className="mt-2 block h-2 w-20 rounded bg-stone-300" />
      </div>
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          className="card-shadow mx-4 mt-3 flex items-center gap-3 rounded-2xl bg-white p-3"
        >
          <span
            className={`h-9 w-9 shrink-0 rounded-full ${
              ["bg-pastel-pink", "bg-pastel-blue", "bg-pastel-mint", "bg-pastel-pink"][i]
            }`}
          />
          <div className="flex-1">
            <span className="block h-2 w-3/4 rounded bg-stone-300" />
            <span className="mt-1.5 block h-2 w-1/2 rounded bg-stone-200" />
          </div>
          <span className="h-2 w-8 rounded bg-stone-800/60" />
        </div>
      ))}
      <div className="absolute inset-x-0 bottom-0 mx-auto mb-4 flex w-2/3 items-center justify-around rounded-2xl bg-stone-900/90 py-3">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-4 w-4 rounded-full bg-stone-400/70" />
        ))}
      </div>
    </div>
  );
}

export default function PhoneTease() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const phoneY = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section
      id="update"
      ref={ref}
      className="overflow-hidden border-y-2 border-ink bg-pastel-blue/40 py-24 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-16 lg:grid-cols-2">
        <div className="flex justify-center">
          <motion.div style={{ y: phoneY }} className="relative">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="relative h-[560px] w-[280px] rounded-[44px] border-2 border-ink bg-ink p-[10px] shadow-chunk-lg md:h-[600px] md:w-[300px]"
              data-testid="phone-tease-mockup"
            >
              <div className="relative h-full w-full overflow-hidden rounded-[36px] bg-bone">
                <div className="absolute left-1/2 top-2.5 z-10 h-6 w-24 -translate-x-1/2 rounded-full bg-ink" />
                <UnreleasedScreen />
                <div className="absolute inset-0 flex items-center justify-center">
                  <Sticker rotate="rotate-2" className="bg-white px-4 py-2">
                    Next interface — in development
                  </Sticker>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>

        <div>
          <Reveal>
            <h2 className="font-serif text-4xl italic leading-[1.05] tracking-tight text-ink md:text-6xl">
              The huge update is
              <br />
              in development.
            </h2>
            <p className="mt-6 max-w-md font-body text-lg leading-relaxed text-stone-600">
              The next version of nailtape™ is underway — a faster order
              workflow, deeper sizing, and changes we'll publish with the
              release.
            </p>
            <p className="mt-3 max-w-md font-body text-base leading-relaxed text-stone-500">
              One email when it ships.
            </p>
            <SubscribeForm source="update_waitlist" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
